import type { CSSProperties } from 'react';
import { Column, Divider, Row, Text } from '~/commonComponents';
import { WarningSolidIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface ISuspendedBannerProps {
  counts: number;
  style?: CSSProperties;
}

export const SuspendedBanner = ({ counts, style }: ISuspendedBannerProps) => {
  if (counts === 0) {
    return null;
  }

  return (
    <Row
      alignItems="center"
      backgroundColor={Colors.warning_30}
      borderColor={Colors.warning_700}
      borderRadius={6}
      borderStyle="solid"
      borderWidth={1}
      gap={12}
      paddingBlock={12}
      paddingInline={10}
      marginInline={72}
      style={style}
    >
      <WarningSolidIcon color={Colors.warning_500} size={24} />
      <Divider height="95%" width={1} color={Colors.warning_500} />
      <Column>
        <Text bold color={Colors.warning_700} marginBottom={4}>
          Jobs Suspended, Update Payment Now
        </Text>
        <Text color={Colors.warning_700}>
          {counts} of your job postings have been suspended due to a failed payment. Please go to
          the Suspended tab to
          <br />
          update your payment method to prevent these jobs from being permanently closed.
        </Text>
      </Column>
    </Row>
  );
};
